<template>
    <div class="analytics-totals">
        <kpi-card
            v-for="card in cards"
            :key="card.key"
            :label="card.label"
            :value="card.value"
            :highlight="card.highlight"
        />
    </div>
</template>

<script>
const METRICS = [
    { key: 'VISITORS', label: 'Visitantes únicos', highlight: true },
    { key: 'VISITS', label: 'Visitas', highlight: false },
    { key: 'PAGE_VIEWS', label: 'Pageviews', highlight: false },
]

const formatNumber = (n) => {
    if (n == null || isNaN(n)) return '—'
    const num = Number(n)
    if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(1).replace('.0', '')} M`
    if (num >= 1_000) return `${(num / 1_000).toFixed(1).replace('.0', '')} k`
    return num.toLocaleString('pt-BR')
}

export default {
    name: 'AnalyticsTotals',
    props: {
        totals: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        cards() {
            return METRICS.map(metric => ({
                key: metric.key,
                label: metric.label,
                value: formatNumber(this.totals?.[metric.key]),
                highlight: metric.highlight,
            }))
        },
    },
}
</script>

<style scoped>
.analytics-totals {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
}

@media (min-width: 768px) {
    .analytics-totals {
        grid-template-columns: repeat(3, 1fr);
    }
}
</style>
